import { isUndefined } from '@aloft/toolkit-shared';
import { ProductColor } from '@aloft/toolkit-sui';

import { ValueFormatter } from '../types.ts';
import { noop } from './formatters/noop.ts';

export function formatValueForCell(
  val: unknown,
  valueFormatter: ValueFormatter = noop,
): { str: string[]; color?: ProductColor } {
  if (isUndefined(val)) return { str: [''] };
  return valueFormatter(val);
}
